<template>
  <!-- 实心饼图 -->
  <div :ref="refId" :datas=datas style="width: 100%;height: 100%;"></div>
</template>
  
  <script>

// refId                 图表id
// datas                 图表数据源
// colorList             颜色值
// nameColor             文字颜色

export default {
  props: ['refId', 'datas', 'titleText', 'colorList', 'nameColor', 'top', 'radius'],
  data() {
    return {
      pieEcharts: '',
      pieOption: {},
    };
  },
  watch: {
    datas: {
      handler(newValue) {
        this.setPieOption(this.refId, newValue, this.colorList, this.nameColor, this.top, this.radius);
      },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.pieEcharts) {
      this.pieEcharts.clear();
    }
  },
  mounted() {
    if (this.datas && this.datas.length > 0) {
      this.$nextTick(() => {
        this.setPieOption(this.refId, this.datas, this.colorList, this.nameColor, this.top, this.radius);
      })
    }
  },
  methods: {
    setPieOption(refId, datas, colorList, nameColor, top, radius) {
      if (!datas || datas.length == 0) {
        datas = []
      }
      let dataList = JSON.parse(JSON.stringify(datas))     //原数据
      dataList.sort((a, b) => { return b.value - a.value })
      this.pieEcharts = this.$echarts.init(this.$refs[refId]);
      this.pieOption = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          top: '10%',
          left: '0%',
          textStyle: {
            color: nameColor ? nameColor : '#ffffff',
            fontSize: 25
          },
        },
        color: colorList ? colorList : ['#6c81f5', '#66ee61', '#e26774', '#1ec9f1', '#ea8dc7', '#e3a87d', '#c9b34c', '#669009', '#d7461a', '#a613b1', '#51f5bd', '#e24ef4', '#f44ecb', '#4ea4f4', '#4e69f4', '#714ef4', '#b74ef4'],
        series: [{
          type: 'pie',
          radius: radius ? radius : '75%',
          center: ['50%', '40%'],
          top: top ? top : null,
          left: '10%',
          minAngle: 15,              //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
          avoidLabelOverlap: true,   //是否启用防止标签重叠策略
          textStyle: {
            color: '#ffffff',
            fontSize: '12',
          },
          label: {
            formatter: '{b}：{c}个',
            textStyle: {
              fontSize: 28
            }
          },
          labelLine: {
            show: true,
            length: 45,
            length2: 45,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: dataList,
        }],
      }
      // 渲染图表
      this.pieEcharts.setOption(this.pieOption);
      this.pieEcharts.resize();
      window.addEventListener('resize', () => {
        this.pieEcharts.resize();
      });
    },
  },
};
  </script>
  
  <style scoped>
</style>
  